import HighchartsReact from "highcharts-react-official";
import Highcharts, { color } from "highcharts";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";
import { React, useEffect, useState } from "react";
NoDataToDisplay(Highcharts);

/**
 * @description 설비진단 > 예지정비 차트
 * @author SONJIEUN
 * @date 01/08/2025
 * @param {*}
 * @return  설비진단 > 예지정비 차트
 */
const UI_3_5_ChartLine = (props) => {
  const data = props.data.length !== 0 ? props.data.data : [];
  const name = props.data.name;

  const options_Line = {
    chart: {
      backgroundColor: "transparent",
      showNoData: "true",
    },
    title: {
      text: null,
    },
    subtitle: {
      text: name,
      style: {
        color: "rgba(255, 255, 255, 0.8)",
        fontSize: "15px",
      },
      align: "left",
    },
    tooltip: {
      crosshairs: true,
      shared: true,
      formatter: function () {
        let tooltip =
          '<span style="font-size: 10px">' +
          Highcharts.dateFormat("%Y년 %m월 %d일 %H시 %M분", this.x) +
          "</span><br/> " +
          this.y;
        return tooltip;
      },
    },
    xAxis: {
      type: "datetime",
      lineColor: "#555",
      labels: {
        style: {
          color: "rgba(255,255,255,0.8)",
        },
        formatter: function () {
          let date = new Date(this.value);
          let hour = date.getHours();
          if (hour === 24) {
            hour = 0;
          }
          return hour + "시";
        },
      },
    },

    yAxis: {
      title: {
        text: null,
      },
      lineWidth: 1,
      lineColor: "#555",
      gridLineColor: "#555",
    },

    plotOptions: {},

    legend: {
      enabled: false,
    },

    lang: {
      noData: "데이터가 존재하지 않습니다", // 데이터가 없을 때 보여줄 메시지
    },

    series: [
      {
        name: "농도",
        lineWidth: 4,
        color: "#29A7A4",
        lineColor: "#29A7A4",
        data: data,
      },
    ],
  };

  return (
    <>
      <figure className="highcharts-figure">
        <HighchartsReact
          highcharts={Highcharts}
          options={options_Line} //options_Scatter , options_Line
        />
      </figure>
    </>
  );
};

export default UI_3_5_ChartLine;
